import React from "react";
import styles from "./CivilLaw.module.css";
import CustomTitle from "../components/CustomTitle";
//import LocationFooter from "./LocationFooter";
const CriminalLaw = () => {
  return (
    <>
      <section className={styles.practiceAreas}>
        <CustomTitle>Criminal Law</CustomTitle>

        <div className={styles.practiceList}>
          <div className={styles.practiceCard}>
            <p>
              We provide robust defense and prosecution support in all criminal
              law matters, from white-collar crimes and financial fraud to
              serious offenses under the penal code. Our criminal law team
              brings courtroom expertise, a deep understanding of procedural
              safeguards, and strategic advisory to individuals and corporations
              alike. We handle bail petitions, trials, appeals, and compliance
              with investigative agencies. Our focus is on protecting the
              constitutional rights of our clients while ensuring fair and
              effective representation across all forums.
            </p>
            <ul>
              <li>White-collar crimes.</li>
              <li>Cybercrimes.</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  <LocationFooter /> */}
    </>
  );
};

export default CriminalLaw;
